import {
  FormSubmitArgs,
  FormViewConfig,
  FormViewService,
  FormViewServiceProvider,
  vsProviderName as FormViewServiceProviderName,
  vsServiceName as FormViewServiceName,
} from "../../../records/forms/formView";
import { RecordDataSource } from "../../../records/grids";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../records/views/recordGridView";
import fieldHelpers from "../../../ui-formly/fieldHelpers";
import {
  LookupManagementConfig,
  LookupManagementServiceProvider,
  vsProviderName as LookupManagementServiceProviderName,
} from "../components/lookupManagement";
import { MachineGameCategory } from "../models/machine";

export const vsObjectName = "machineGameCategory";

MachineGameCategoryConfig.$inject = [
  FormViewServiceProviderName,
  RecordGridViewServiceProviderName,
  LookupManagementServiceProviderName,
];

const url = "/api/machines/MachineGameCategory";

export function MachineGameCategoryConfig(
  formViewServiceProvider: FormViewServiceProvider,
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  lookupManagementServiceProvider: LookupManagementServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(
    vsObjectName,
    getGridConfig
  );
  lookupManagementServiceProvider.addLookup(vsObjectName, {
    displayName: "Game Category",
    config: [
      ServerUtilityName,
      (serverUtility: ServerUtility) => {
        const config: LookupManagementConfig = {
          fetchFormModel(id) {
            return serverUtility.querySingle({
              url,
              query: { Id: id },
            });
          },
        };
        return config;
      },
    ],
  });
  formViewServiceProvider.addFormViewConfig(vsObjectName, getFormConfig);
}

getGridConfig.$inject = [ServerUtilityName, ColumnDefinitionServiceName];
function getGridConfig(
  serverUtility: ServerUtility,
  columnDefinitionService: ColumnDefinitionService
): GridConfiguration {
  return {
    columns: [
      columnDefinitionService.getStringColDef({
        field: "Name",
        header: "Game Category",
      }),
      columnDefinitionService.getStringColDef({
        field: "GameType",
        header: "Game Type",
      }),
    ],
    gridDataSource: new RecordDataSource(serverUtility, url),
    defaultSort: "Name",
    namePlural: "Game Categories",
    nameSingular: "Game Category",
    showAddButton: true,
    showAddButtonPermission: "machineEdit",
    showSelectButtons: false,
  };
}

getFormConfig.$inject = [FormViewServiceName];
function getFormConfig(formViewService: FormViewService): FormViewConfig {
  return {
    fields: [
      fieldHelpers.simpleStringField({
        key: "Name",
        label: "Game Category",
        required: true,
      }),
      fieldHelpers.simpleStringField({
        key: "GameType",
        label: "Game Type",
        maxlength: 10,
      }),
    ],
    title: (model) =>
      model.Id ? "Edit Game Category" : "Create Game Category",
    name: vsObjectName,
    submitForm: (args: FormSubmitArgs) => {
      const model = <MachineGameCategory>args.model;
      return formViewService.saveForm({
        formObject: model,
        formViewController: args.formViewController,
        url,
      });
    },
  };
}
